<template>
  <zm-dialog
    ref="dialog"
    v-bind="$attrs"
    class="opc-dialog"
    :class="{
      'opc-modal-dialog': isLegacyModalUI,
    }"
    :show-close="!isLegacyModalUI"
    :aria-label="dialogName"
  >
    <template #header>
      <nav-back v-if="isLegacyModalUI" class="opc-modal-dialog__nav-back" :back-handler="handleBeforeClose" />
      <div class="zoom-dialog__title" v-if="$attrs.title">{{ $attrs.title }}</div>
      <slot name="title" v-else-if="$slots.title" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps" :key="slotName">
      <slot :name="slotName" v-bind="slotProps"></slot>
    </template>
  </zm-dialog>
</template>

<script>
import NavBack from '@/components/nav-back.vue';
import { hideModalDialogCloseButton, showModalDialogCloseButton } from '@/utils/modal-utils.js';

export default {
  name: 'BillingDialog',
  components: { NavBack },
  inheritAttrs: false,
  props: {
    dialogName: {
      type: String,
      default: undefined,
    },
  },
  emits: ['back-event'],
  data() {
    return {
      navBackInstance: null,
    };
  },
  computed: {
    isLegacyModalUI() {
      return this.$context?.is?.modal && !this.$context?.is?.modal2Column;
    },
    isDialogOpen() {
      const attrs = this.$attrs || {};
      return Boolean(attrs.modelValue ?? attrs.value ?? attrs.visible);
    },
  },
  watch: {
    isDialogOpen(newVal, oldVal) {
      if (!this.$context?.is?.modal2Column) return;
      if (newVal === oldVal) return;
      if (newVal) {
        hideModalDialogCloseButton();
      } else if (oldVal) {
        showModalDialogCloseButton();
      }
    },
  },
  beforeUnmount() {
    if (this.$context?.is?.modal2Column && this.isDialogOpen) {
      showModalDialogCloseButton();
    }
  },
  methods: {
    handleBeforeClose() {
      this.$emit('back-event');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import "@/styles/modal.scss";

.opc-modal-dialog {
  .opc-modal-dialog__nav-back {
    margin-bottom: 12px;
  }
}

</style>
